import { evaluateField } from "utils/validation-rules";

export const FIELD_ERROR_CLASS = "field--error";
export const FIELD_ERROR_TEXT_CLASS = "input--errors";

export const findFieldRoot = (element) => {
  if (!element || !element.closest) return null;
  return element.closest(".field") || element.parentElement;
};

const readRangeValue = (element) => {
  const range =
    element.matches && element.matches("input[type='range']")
      ? element
      : element.querySelector("input[type='range']");
  if (!range) return null;
  return range.value || range.min || "";
};

export const readControlValue = (element) => {
  if (!element) return "";
  if (element.tagName === "SELECT" || element.tagName === "INPUT") {
    if (element.type === "checkbox") return element.checked;
    if (element.type === "range") return readRangeValue(element) || "";
    return element.value || "";
  }
  const selected = element.querySelector("[data-value][data-selected='true']");
  if (selected) return selected.getAttribute("data-value") || "";
  const checked = element.querySelector("input[type='radio']:checked");
  if (checked) return checked.value || "";
  const rangeValue = readRangeValue(element);
  if (rangeValue !== null) return rangeValue;
  return "";
};

export const resolveFieldError = (
  formField,
  value,
  messages = {},
  context = {},
) => {
  if (!formField) return "";
  return evaluateField(formField, value, context, messages) || "";
};

export const applyFieldError = (element, message) => {
  const root = findFieldRoot(element);
  if (!root) return;
  const doc = element.ownerDocument || document;
  let node = root.querySelector("." + FIELD_ERROR_TEXT_CLASS);
  if (!message) {
    root.classList.remove(FIELD_ERROR_CLASS);
    if (element.removeAttribute) element.removeAttribute("aria-invalid");
    if (node) node.remove();
    return;
  }
  root.classList.add(FIELD_ERROR_CLASS);
  if (element.setAttribute) element.setAttribute("aria-invalid", "true");
  if (!node) {
    node = doc.createElement("p");
    node.className = FIELD_ERROR_TEXT_CLASS;
    root.appendChild(node);
  }
  node.textContent = message;
};

export const showFieldError = (element, formField, messages, context) => {
  if (!element) return "";
  const message = resolveFieldError(
    formField,
    readControlValue(element),
    messages,
    context,
  );
  applyFieldError(element, message);
  return message;
};
